import type { TFormData } from './Quiz.helpers';

/** The `form_data` fields every quiz `formSubmission` event shares; `extra` adds step-specific ones. */
export const buildQuizFormData = (
	brand: string,
	step: string,
	formResult: string | undefined,
	formData: TFormData,
	extra: Record<string, unknown> = {}
) => ({
	brand,
	product_line: formData.form.product_line,
	submission_date: new Date().toISOString(),
	form_title: formData.form.form_title,
	form_description: formData.form.form_description,
	form_type: formData.form.form_type,
	form_result: formResult,
	form_step: step,
	...extra,
});
